import { createTheme } from '@mui/material';
// import PhenomenaRegularEot from '../fonts/phenomena/Phenomena-Regular.eot'; // Remove EOT
import PhenomenaRegularWoff from '../fonts/phenomena/Phenomena-Regular.woff'; // Add WOFF
import PhenomenaRegularWoff2 from '../fonts/phenomena/Phenomena-Regular.woff2';
// import PhenomenaBoldEot from '../fonts/phenomena/Phenomena-Bold.eot'; // Remove EOT
import PhenomenaBoldWoff from '../fonts/phenomena/Phenomena-Bold.woff'; // Add WOFF
import PhenomenaBoldWoff2 from '../fonts/phenomena/Phenomena-Bold.woff2';

const theme = createTheme({
	palette: {
		background: {
			default: '#ffffff',
		},
		primary: {
			main: '#202766',
		},
		secondary: {
			main: '#F7A300',
		},
		warning: {
			main: '#FF8F00',
		},
	},
	typography: {
		h1: {
			fontFamily: 'Phenomena-Bold, sans-serif',
			fontSize: '2.5rem',
		},
		h2: {
			fontFamily: 'Phenomena-Bold, sans-serif',
			fontSize: '2rem',
		},
		h3: {
			fontFamily: 'Phenomena-Regular, sans-serif',
			fontSize: '1.75rem',
		},
		h4: {
			fontFamily: 'Phenomena-Regular, sans-serif',
			fontSize: '1.5rem',
		},
		h5: {
			fontFamily: 'Phenomena-Regular, sans-serif',
			fontSize: '1.25rem',
		},
		h6: {
			fontFamily: 'Phenomena-Regular, sans-serif',
			fontSize: '1.5rem',
		},
		fontFamily: 'Manrope, sans-serif',
	},
	components: {
		MuiCssBaseline: {
			styleOverrides: `
        @font-face {
          font-family: 'Phenomena-Regular';
          src: local('Phenomena-Regular'),
               url(${PhenomenaRegularWoff2}) format('woff2'),
               url(${PhenomenaRegularWoff}) format('woff');
        }

		@font-face {
			font-family: 'Phenomena-Bold';
			src: local('Phenomena-Bold'),
				 url(${PhenomenaBoldWoff2}) format('woff2'),
				 url(${PhenomenaBoldWoff}) format('woff');
		  }
      `,
		},
		MuiCard: {
			styleOverrides: {
				root: {
					borderRadius: '10px',
				},
			},
		},
	},
});

export default theme;
